module.exports = __webpack_public_path__ + "static/cari-mora-301cb699722c082d636c08ddb012bdb4.jpg";